var App = App || {};

App.NavDesktop = (function ($) {
    'use strict';

    function Init() {

        let mmActive = false;
        const mmSpeed = 300;

        const mmContainer = $(".nav-desktop > ul");
        const mmTrigger = mmContainer.children("li").children("a, button");
        const mmItems = mmContainer.find(".nav-desktop-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            NavClose(mmTrigger, mmSpeed);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                NavClose($(this).children("li").children("a, button"), 1);
            }
        });

        mmTrigger.on("mouseenter", function () {
            NavOpen($(this), mmActive ? 1 : mmSpeed);
            mmActive = true;
        }).on("focus", function () {
            NavOpen($(this), 1);
            mmActive = true;
        }).on("blur", function () {
            if (mmActive === false) {
                NavClose($(this), 1);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".nav-desktop-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    NavClose($(this), mmSpeed);
                    break;
            }
        });

        mmItems.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".nav-desktop-menu").parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".nav-desktop-menu").parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".nav-desktop-menu").siblings("a, button");
                    NavClose(MenuButton, mmSpeed);
                    break;
            }
        });

    }

    function NavOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").siblings(".nav-desktop-menu").stop().slideDown(speed);
        NavClose(trigger.parents("li").siblings("li").children("a, button"), speed);
    }

    function NavClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").siblings(".nav-desktop-menu").stop().slideUp(speed);
    }

    return {
        Init: Init
    };

})(jQuery);